import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { updatePNC } from "@store/actions/beneficiaryAction";
import { formatName } from "@pages/Beneficiary-block/WomenComponent/PregnancyTracking/pregnancyUtils";
import './hbycServiceView.css';
import { errorLogger } from "@utils/applicationLogUtils";
import { getData, postDataJSON } from "@services/CommonApiService";
import endpoints from "@config/endpoints";
import { useSelector } from "react-redux";
import { RootState } from "@store/reducers";
import DetailRow from "@components/common/DetailRow";
import { COMMON_HBYC_CONSTANTS, commonConstantHbycField, getOngoingHBYCDetails, HBYC_API_DETAILS, HBYC_DETAILS, HBYC_TITLES, hbycKey } from "./ChildtrackingConstant";


const HBYCServiceView = () => {
    const childHbycData: any = {};

    const viewEditMetaData = useSelector((state: RootState) => state.beneficiary.viewEditMetaData);
    const childDetails = useSelector((state: RootState) => state.beneficiary.childDetails);
    const [HBYCServiceData, setHBYCServiceData] = useState<any>([]);
    const dispatch = useDispatch();
    const hbycOngoingMetaData = getOngoingHBYCDetails(childDetails?.dob, viewEditMetaData?.ancVisitDate);

    const hbycValue = hbycOngoingMetaData[0]?.hbyc;
    Object.assign(childHbycData, HBYC_DETAILS[hbycValue] || {});

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const payload = {
                visityId: viewEditMetaData?.serviceVisitId
            }
            const childGrowthInfoPayload = {
                serviceVisitId: viewEditMetaData?.serviceVisitId,
                partitionKeyTrxnDate: viewEditMetaData?.ancVisitDate
            };
            const redFlagResponse = await postDataJSON<any>(`${endpoints.childGrowthInfo}`, childGrowthInfoPayload);
            const res = await getData<any>(`${endpoints.getCompletedHbycServiceListByVisitService}/${viewEditMetaData?.serviceVisitId}`)
            if (res) {
                mapData(res, redFlagResponse);
            }
        } catch (error: any) {
            errorLogger(error?.response?.data || error?.response || error)
        }
    }

    const getHbycTitle = () => {
        const hbycValue = hbycOngoingMetaData[0]?.hbyc;
        return HBYC_TITLES[hbycValue] || COMMON_HBYC_CONSTANTS.HBYC_DETAILS;
    };

    const mapData = (data: any, redFlagResponse: any) => {
        const initialState = {
            weightOfBaby: { value: null },
            lengthOfBaby: { value: null },
            growthChartOfMcpCard: { value: null },
            redFlagSign: { value: null },
            weatherChildIsSick: { value: null },
            weatherChildIsReffered: { value: null },
            breastfeedingContinue: { value: null },
            hivTest: { value: null },
            nacpRefferalFacility: { value: null},
            whetherComplementaryFeedingAdequatelyProvided: { value: null },
            whetherComplementaryFeedingStartedAt6months: { value: null },
            whetherBottleOfIfaProvided: { value: null },
            whetherOrsProvided: { value: null },
            syphilisTest: { value: commonConstantHbycField.NOT_DONE },
        };
        const updatedFormState = data?.data?.reduce((acc: any, item: any) => {
            const value = item.service_report;
            switch (item.service_code) {
                case HBYC_API_DETAILS.WEIGHT_IN_KEY:
                    acc.weightOfBaby.value = value
                    break;
                case HBYC_API_DETAILS.HEIGHT_IN_KEY:
                    acc.lengthOfBaby.value = value
                    break;
                case HBYC_API_DETAILS.RED_FLAG_SIGN_KEY:
                    acc.redFlagSign.value =
                        item.service_report || item.red_flag_issue_for_baby_code;
                    break;
                case HBYC_API_DETAILS.COLOR_ZONE:
                    acc.growthChartOfMcpCard.value =
                        item.service_report || item.growth_zone_colour_name;
                    break;
                case HBYC_API_DETAILS.WHETHER_CHILD_IS_REFERRED_KEY:
                    acc.weatherChildIsReffered.value = value
                    break;
                case HBYC_API_DETAILS.WHETHER_EXCLUSIVE_BREASTFEEDING_CONTINUED_KEY:
                    acc.breastfeedingContinue.value = value
                    break;
                case HBYC_API_DETAILS.SYPHILIS_TEST_KEY:
                    acc.syphilisTest.value = value
                    break;
                case HBYC_API_DETAILS.HIV_TEST_KEY:
                    acc.hivTest.value = value
                    break;
                case HBYC_API_DETAILS.NACP_REFERRAL_FACILITY:
                    acc.nacpRefferalFacility.value = value
                    break;
                case HBYC_API_DETAILS.WHETHER_ORS_PROVIDED_KEY:
                    acc.whetherOrsProvided.value = value
                    break;
                case HBYC_API_DETAILS.WHEATER_COMPLEMENTARY_FEEDING_STARTED_KEY:
                    acc.whetherComplementaryFeedingStartedAt6months.value = value
                    break;
                case HBYC_API_DETAILS.WHEATER_COMPLEMENTARY_FEEDING_ADEQUATELY_PROVIDED_KEY:
                    acc.whetherComplementaryFeedingAdequatelyProvided.value = value
                    break;
                case HBYC_API_DETAILS.WHEATER_BOTTLE_OF_IFA_PROVIDED_KEY:
                    acc.whetherBottleOfIfaProvided.value = value
                    break;
                case HBYC_API_DETAILS.WHETHER_CHILD_IS_SICK_KEY:
                    if (acc.weatherChildIsSick.value) {
                        acc.weatherChildIsSick.value += `, ${value}`;
                    } else {
                        acc.weatherChildIsSick.value = value;
                    }
                    break;
                default:
                    break;
            }
            return acc;
        }, initialState);

        if (redFlagResponse?.data?.length > 0) {
        const lastIndex = redFlagResponse.data.length - 1;
        updatedFormState.redFlagSign.value = redFlagResponse?.data?.map((item:any) => item?.red_flag_issue_for_baby_name).join(", ");
        updatedFormState.growthChartOfMcpCard.value = redFlagResponse.data[lastIndex].growth_zone_colour_name;
    }

        const facilityDetailsObj = data?.data[0];

        if (facilityDetailsObj) {
            const { facility_name, facility_type_name, healthprovider_f_name, healthprovider_l_name, mobiliser_f_name, mobiliser_l_name } = facilityDetailsObj;
            const healthProviderName = formatName(healthprovider_f_name, healthprovider_l_name);
            const mobiliserName = formatName(mobiliser_f_name, mobiliser_l_name);
            const localFacilityDetails = { facility_name, facility_type_name, healthProviderName, mobiliserName };

            dispatch(updatePNC("viewAndEditFacilityDetails", localFacilityDetails));
        }
        setHBYCServiceData(updatedFormState);
    }

    const showNotDone = (key: string) => {
        if ((key === hbycKey.HIV_TEST) && !HBYCServiceData?.[key]?.value) {
            return commonConstantHbycField.NOT_DONE;
        }
        return HBYCServiceData?.[key]?.value;
    };

    return (
        <>
            <div className="overview_hbyc">
                <div className="hbyc_header">{getHbycTitle()}</div>
                <div className="overview-details">
                    {childHbycData &&
                        Object.keys(childHbycData).map((key) => {
                            const field = childHbycData[key];
                            return (
                                <DetailRow
                                    key={key}
                                    label={field["#title"]}
                                    value={showNotDone(key)}
                                />
                            );
                        })}
                </div>
            </div>
        </>
    );
}
export default HBYCServiceView;